import * as React from 'react';
import { SchoolEventIndividualData } from 'Src/models/event';
import {
  convertPointsToStringWithoutDelimeter,
  getExtraPointsByStudent,
  getIndividualScoreByStudent
} from '../../../../../../../helpers/event/schoolEventViewHelper';
import { isEventStatusFinished } from '../../../../../../../helpers/event/event';
import { SchoolEvent } from '../../../../../../../models/event';
import { EventParticipantIdentity } from 'Src/components/EventParticipantIdentity/EventParticipantIdentity';

interface Props {
  players: SchoolEventIndividualData[];
  event: SchoolEvent;
  currentUserId: string;
  currentUserAvatar?: string;
}

export function StudentEventIndividualPlayers(props: Props) {
  const { players, event, currentUserId, currentUserAvatar } = props;
  const sortedPlayers = [...players].sort((a, b) => {
    const currentDifference =
      Number(String(b.userId) === String(currentUserId)) - Number(String(a.userId) === String(currentUserId));
    if (currentDifference !== 0) return currentDifference;
    return `${a.lastName || ''} ${a.firstName || ''}`.localeCompare(`${b.lastName || ''} ${b.firstName || ''}`);
  });

  const rows = sortedPlayers.map((player, playerIndex) => {
    const { userId, permissionId } = player;
    const playerPoints = getIndividualScoreByStudent(event, userId, permissionId);
    const playerPointsStr = convertPointsToStringWithoutDelimeter(event, playerPoints);
    const extraPoints = getExtraPointsByStudent(event, userId);
    const extraPointsStr = String(extraPoints);
    const isEventFinished = isEventStatusFinished(event);
    const isCurrentUser = String(userId) === String(currentUserId);

    return (
      <tr key={`school_players_${player.id}`} className={isCurrentUser ? 'eventParticipantRow--owned' : ''}>
        <td className="eventParticipantRow__number">
          <div>{`${playerIndex + 1} `}</div>
        </td>

        <td style={{ width: '25%' }}>
          <div className={'ml-3'}>
            <EventParticipantIdentity
              firstName={player.firstName}
              lastName={player.lastName}
              isOwned={isCurrentUser}
              avatar={currentUserAvatar}
              ownedLabel="You"
            />
          </div>
        </td>

        <td style={{ width: '25%' }}>
          <div className="ml-3 eventParticipantLastName">{player.lastName}</div>
        </td>

        <td style={{ width: '30%' }}>
          {isEventFinished && <div className={'ml-3 font-weight-bold'}>{`${playerPointsStr} `}</div>}
        </td>

        <td style={{ width: '15%' }}>
          {isEventFinished && <div className={'ml-3 font-weight-bold'}>{`${extraPointsStr} `}</div>}
        </td>
      </tr>
    );
  });
  return (
    <table className={'w-100 eventParticipantRoster'}>
      <tbody>{rows}</tbody>
    </table>
  );
}
